<template>
  <div class="payment-result-page">
    <div v-if="loading" class="result-card">
      <div class="result-icon loading">
        <span></span>
      </div>
      <h1>İşlem kontrol ediliyor</h1>
      <p class="result-desc">Lütfen bekleyiniz...</p>
    </div>

    <div v-else-if="result && result.status === 'paid'" class="result-card success">
      <div class="result-icon success">
        <svg viewBox="0 0 24 24" width="54" height="54" fill="none">
          <path
            d="M20 6L9 17l-5-5"
            stroke="currentColor"
            stroke-width="2.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <h1>Ödeme Başarılı</h1>
      <p class="result-desc">Tahsilat işlemi başarıyla tamamlandı.</p>

      <div class="result-info">
        <div class="info-row">
          <span>Sipariş No</span>
          <strong>{{ orderNo || "-" }}</strong>
        </div>

        <div class="info-row">
          <span>Müşteri</span>
          <strong>{{ customerName || "-" }}</strong>
        </div>

        <div class="info-row">
          <span>Tutar</span>
          <strong>{{ fmtMoney(totalAmount) }}</strong>
        </div>

        <div class="info-row">
          <span>Taksit</span>
          <strong>{{ installment || 1 }}</strong>
        </div>

        <div class="info-row">
          <span>Sağlayıcı</span>
          <strong>{{ providerName || "-" }}</strong>
        </div>
      </div>

      <div class="result-actions">
        <button class="btn primary" @click="goTahsilat">Tahsilat Listesine Git</button>
      </div>
    </div>

    <div v-else-if="result && result.status === 'failed'" class="result-card failed">
      <div class="result-icon failed">
        <svg viewBox="0 0 24 24" width="50" height="50" fill="none">
          <path
            d="M15 9l-6 6M9 9l6 6"
            stroke="currentColor"
            stroke-width="2.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <h1>Ödeme Başarısız</h1>
      <p class="result-desc">Tahsilat işlemi tamamlanamadı.</p>

      <div class="result-info">
        <div class="info-row">
          <span>Sipariş No</span>
          <strong>{{ orderNo || "-" }}</strong>
        </div>

        <div class="info-row">
          <span>Sağlayıcı</span>
          <strong>{{ providerName || "-" }}</strong>
        </div>

        <div class="info-row info-row-message">
          <span>Mesaj</span>
          <strong>{{ errorMessage || "İşlem sırasında hata oluştu" }}</strong>
        </div>
      </div>

      <div class="result-actions">
        <button class="btn primary" @click="goTahsilat">Tahsilat Listesine Git</button>
      </div>
    </div>

    <div v-else-if="result && (result.status === '3d_pending' || result.status === 'pending')" class="result-card pending">
      <div class="result-icon pending">
        <svg viewBox="0 0 24 24" width="50" height="50" fill="none">
          <path
            d="M12 8v4l3 3"
            stroke="currentColor"
            stroke-width="2.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle
            cx="12"
            cy="12"
            r="9"
            stroke="currentColor"
            stroke-width="2"
          />
        </svg>
      </div>

      <h1>İşlem Bekleniyor</h1>
      <p class="result-desc">Ödeme işlemi henüz tamamlanmadı.</p>

      <div class="result-info">
        <div class="info-row">
          <span>Sipariş No</span>
          <strong>{{ orderNo || "-" }}</strong>
        </div>

        <div class="info-row">
          <span>Durum</span>
          <strong>{{ statusText }}</strong>
        </div>
      </div>

      <div class="result-actions">
        <button class="btn primary" @click="goTahsilat">Tahsilat Listesine Git</button>
      </div>
    </div>

    <div v-else class="result-card failed">
      <div class="result-icon failed">
        <span>!</span>
      </div>
      <h1>Veri alınamadı</h1>
      <p class="result-desc">{{ errorMessage || "Sonuç kaydı bulunamadı." }}</p>

      <!-- <div class="result-actions">
        <button class="btn primary" @click="goTahsilat">Tahsilat Listesine Git</button>
        <button class="btn" @click="goDashboard">Dashboard</button>
      </div> -->
    </div>
  </div>
</template>

<script>
import db from "../../db";
export default {
  name: "FinansOdemeSonuc",

  data() {
    return {
      loading: true,
      payload: null,
      notifyTry: 0
    };
  },

  computed: {
    result() {
      return this.payload;
    },

    orderNo() {
      return (this.result && this.result.orderNo) || "";
    },

    providerName() {
      return (this.result && this.result.provider && this.result.provider.name) ||
        (this.result && this.result.provider && this.result.provider.code) ||
        "";
    },

    customerName() {
      return (this.result && this.result.customer && this.result.customer.name) || "";
    },

    installment() {
      return Number(
        (this.result &&
          this.result.amounts &&
          this.result.amounts.installment) || 1
      );
    },

    totalAmount() {
      return Number(
        (this.result &&
          this.result.amounts &&
          this.result.amounts.totalAmount) || 0
      );
    },

    currency() {
      return String(
        (this.result &&
          this.result.amounts &&
          this.result.amounts.currency) || "TRY"
      );
    },

    errorMessage() {
      return (this.result && this.result.errorMessage) || "";
    },

    statusText() {
      const s = String((this.result && this.result.status) || "");
      const map = {
        paid: "Başarılı",
        failed: "Başarısız",
        pending: "Bekliyor",
        "3d_pending": "3D Bekliyor",
        cancelled: "İptal",
        refunded: "İade"
      };
      return map[s] || s || "-";
    }
  },

    created() {
              this.$store.setLoading([false, ""]);

      this.readResult();
    this.fetchServerResultIfNeeded().then(() => {
      this.maybeNotifyTahsilat();
    });
    },

    methods: {
    readResult() {
      try {
        const raw = sessionStorage.getItem("payment_result");
        this.payload = raw ? JSON.parse(raw) : null;

        // Direkt callback redirect'inde sessionStorage olmayabilir; query'den minimum payload uret.
        const q = (this.$route && this.$route.query) ? this.$route.query : {};
        const qOrderNo = String(q.orderNo || "").trim();

        // Session'daki eski kayit baska orderNo'ya aitse query'yi esas al.
        if (qOrderNo && this.payload && this.payload.orderNo && String(this.payload.orderNo).trim() !== qOrderNo) {
          this.payload = null;
        }

        if (!this.payload || !this.payload.status) {
          const status = String(q.status || "").trim() || "3d_pending";
          const providerCode = String(q.provider || "").trim().toLowerCase();

          this.payload = {
            success: status === "paid",
            status: status,
            orderNo: qOrderNo,
            clientOrderReference: String(q.ref || "").trim(),
            provider: {
              code: providerCode,
              name: providerCode,
              type: ""
            },
            customer: {},
            amounts: {
              installment: 1,
              amount: 0,
              feeAmount: 0,
              totalAmount: 0,
              currency: "TRY"
            },
            errorCode: String(q.errorCode || "").trim() || null,
            errorMessage: String(q.errorMessage || "").trim() || null
          };

          try {
            sessionStorage.setItem("payment_result", JSON.stringify(this.payload || {}));
          } catch (e) { }
        } else {
          // Session payload var; errorMessage bossa query'den tamamla.
          const qErr = String(q.errorMessage || "").trim();
          if (qErr && (!this.payload.errorMessage || !String(this.payload.errorMessage).trim())) {
            this.payload.errorMessage = qErr;
            try {
              sessionStorage.setItem("payment_result", JSON.stringify(this.payload || {}));
            } catch (e) { }
          }
        }
      } catch (err) {
        console.error("PAYMENT_RESULT_READ_ERROR", err);
        this.payload = null;
      } finally {
        this.loading = false;
      }
    },

    async fetchServerResultIfNeeded() {
      try {
        const orderNo = (this.payload && this.payload.orderNo) ? String(this.payload.orderNo).trim() : "";
        if (!orderNo) return;

        const res = await this.$request.get("payment/result/" + encodeURIComponent(orderNo));
        const body = res && res.data ? res.data : res;
        const row = body && body.data ? body.data : body;
        if (!row) return;

        // result endpoint DB formatinda donuyor; ekranda kullandigimiz payload seklini koru.
        const next = { ...(this.payload || {}) };
        const dbStatus = String(row.status || "").trim();

        if (dbStatus) {
          next.status = dbStatus;
          next.success = dbStatus === "paid";
        }

        next.orderNo = next.orderNo || row.order_no || "";

        // Provider
        const pName = row.provider_name || row.provider_code || "";
        const pCode = row.provider_code || (next.provider && next.provider.code) || "";
        next.provider = next.provider || {};
        if (pCode) next.provider.code = String(pCode).toLowerCase();
        if (pName) next.provider.name = pName;

        // Customer
        next.customer = next.customer || {};
        if (row.customer_name) next.customer.name = row.customer_name;
        if (row.customer_email) next.customer.email = row.customer_email;
        if (row.customer_phone) next.customer.phone = row.customer_phone;
        if (row.carid != null) next.customer.carid = row.carid;

        // Amounts
        next.amounts = next.amounts || {};
        if (row.installment != null) next.amounts.installment = Number(row.installment || 1);
        if (row.amount != null) next.amounts.amount = Number(row.amount || 0);
        if (row.fee_amount != null) next.amounts.feeAmount = Number(row.fee_amount || 0);
        if (row.total_amount != null) next.amounts.totalAmount = Number(row.total_amount || 0);
        if (row.currency) next.amounts.currency = row.currency;

        // Source
        if (row.payment_source) next.payment_source = row.payment_source;

        // Error message: query/session > DB fail_message
        if (!next.errorMessage || !String(next.errorMessage).trim()) {
          next.errorMessage = row.fail_message || next.errorMessage || "";
        }

        this.payload = next;

        try {
          sessionStorage.setItem("payment_result", JSON.stringify(this.payload || {}));
        } catch (e) { }
      } catch (e) {
        console.error("PAYMENT_RESULT_FETCH_ERROR", e);
      }
    },

    async maybeNotifyTahsilat() {
      try {
        if (!this.payload || String(this.payload.status || "").trim() !== "paid") return;
        if (String(this.payload.payment_source || "").trim() !== "manuel") return;

        const orderNo = String(this.payload.orderNo || "").trim();
        if (!orderNo) return;

        const key = "bildirim_tahsilat_" + orderNo;
        if (sessionStorage.getItem(key) === "1") return;

        const hesap = this.$request.ayar();
        let cari = (this.$store && this.$store.aktifCari) ? this.$store.aktifCari : null;

        // Cari henüz yüklenmemiş olabilir; kısa süre tekrar dene.
        if (!cari || !cari.kod) {
          // Store gelmediyse DB'den carid ile dene (tahsilat/add -> customer.carid = cari.guid)
          const carid = this.payload && this.payload.customer ? String(this.payload.customer.carid || "").trim() : "";
          if (carid) {
            try {
              const fromDb = await db.caris.where("guid").equals(carid).first();
              if (fromDb && fromDb.kod) {
                cari = fromDb;
              }
            } catch (e) { }
          }

          if (cari && cari.kod) {
            // ok, devam
          } else {
          if ((this.notifyTry || 0) < 10) {
            this.notifyTry = (this.notifyTry || 0) + 1;
            setTimeout(() => this.maybeNotifyTahsilat(), 300);
          }
          return;
          }
        }

        const bildirimObje = {
          tip: 2,
          alias: "Tahsilat",
          renk: "#a855f7",
          link: "tahsilat",
          seri: orderNo,
          sira: "",
          odeme: orderNo,
          kid: hesap.kid,
          baslik: cari.unvan || (this.payload.customer && this.payload.customer.name) || "",
          ckod: cari.kod,
          names: hesap.kad
        };

        await this.$request.post("crm/bildirim/add", bildirimObje);
        sessionStorage.setItem(key, "1");
      } catch (e) { }
    },

    fmtMoney(val) {
      const n = Number(val || 0);
      const symbol = this.currency === "TRY" ? "₺" : this.currency + " ";
      return symbol + " " + n.toLocaleString("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    goTahsilat() {
      this.$router.push("/tahsilat/liste");
    }
  }
};
</script>

<style scoped>
.payment-result-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f8fafc;
}

.result-card {
  width: 100%;
  max-width: 560px;
  background: #fff;
  border: 1px solid #e5eaf1;
  border-radius: 24px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);
  padding: 36px 28px;
  text-align: center;
}

.result-icon {
  width: 96px;
  height: 96px;
  border-radius: 999px;
  margin: 0 auto 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.result-icon.success {
  background: #16a34a;
}

.result-icon.failed {
  background: #dc2626;
}

.result-icon.pending {
  background: #2563eb;
}

.result-icon.loading {
  background: #e5e7eb;
  position: relative;
  overflow: hidden;
}

.result-icon.loading span {
  width: 38px;
  height: 38px;
  border: 4px solid #cbd5e1;
  border-top-color: #2563eb;
  border-radius: 50%;
  display: inline-block;
  animation: spin 1s linear infinite;
}

h1 {
  margin: 0;
  font-size: 30px;
  color: #0f172a;
  font-weight: 800;
}

.result-desc {
  margin: 10px 0 0;
  color: #64748b;
  font-size: 15px;
}

.result-info {
  margin-top: 26px;
  border: 1px solid #edf2f7;
  border-radius: 18px;
  overflow: hidden;
  background: #f8fafc;
}

.info-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid #edf2f7;
  text-align: left;
}

.info-row:last-child {
  border-bottom: none;
}

.info-row span {
  color: #64748b;
  font-size: 13px;
  font-weight: 700;
}

.info-row strong {
  color: #0f172a;
  font-size: 14px;
  font-weight: 800;
  text-align: right;
  word-break: break-word;
  max-width: 65%;
}

.info-row-message strong {
  color: #b91c1c;
}

.result-actions {
  margin-top: 24px;
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  min-width: 180px;
  height: 46px;
  padding: 0 16px;
  border-radius: 14px;
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #0f172a;
  font-weight: 700;
  cursor: pointer;
}

.btn.primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 640px) {
  .result-card {
    padding: 28px 18px;
  }

  h1 {
    font-size: 25px;
  }

  .result-actions {
    flex-direction: column;
  }

  .btn {
    width: 100%;
    min-width: 0;
  }

  .info-row {
    flex-direction: column;
  }

  .info-row strong {
    max-width: 100%;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/tahsilat/sonuc.vue